import { CallCenterUserState } from "@/Common/Api/CallCenter/Responses/CallCenterUserState";
import { IRealTimeNotificationMessage } from "@/Common/Api/RealTimeNotification/Dto/RealTimeNotificationMessage";
import { RealTimeNotificationOperation } from "@/Common/Api/RealTimeNotification/Dto/RealTimeNotificationOperation";
import { BaseStore } from "@/Common/Stores/BaseStore";
import { RealTimeNotificationEventHandler } from "@/Common/Stores/Handlers/RealTimeNotificationEventHandler";
import { SessionStore } from "@/Globals/Stores/SessionStore";

interface ICallCenterNotificationMessage extends IRealTimeNotificationMessage {
    /**
     * Updated UserState DTO.
     */
    UserState: CallCenterUserState;
}

/**
 * Class representing the real-time notification handler for the CallCenter component.
 */
class CallCenterRealTimeNotificationHandler extends RealTimeNotificationEventHandler {
    /**
     * Create a CallCenterRealTimeNotificationHandler instance.
     * @param store The store where the real-time notification handler is going to be used.
     */
    constructor(store: BaseStore) {
        super(store);
        this.RegisterOperation(RealTimeNotificationOperation.UpdateCallCenterUserState, this.UserStateUpdated);
    }

    /**
    * Triggers a UserState update when the related real-time notification message is received.
    * @param message The messages that has been recieved.
    */
    private UserStateUpdated(message: ICallCenterNotificationMessage, store: SessionStore): void {
        store.updateCallCenterUserState(message.UserState);
    }
}

export { CallCenterRealTimeNotificationHandler };
